import { Textarea } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../../../../../../../../../../../hooks/useDebouncedCallback'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { INVOICE_LINE_DESCRIPTION_CONTENT_CHARACTER_LIMIT } from '../../../../../../../../constants/invoiceLineDescriptionCharacterLimit'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineQuantityProps = CommonInvoiceLineFieldProps

export const InvoiceDescription = ({ disabled = false, lineIndex }: InvoiceLineQuantityProps) => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  const handleDebouncedTextareaChange = useDebouncedCallback((value: string) =>
    trackInvoiceEditor('Form - Invoice lines - Description content changed', {
      messageLength: value.length,
    }),
  )

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.content`}
      render={({ field: { onChange, value, ...rest } }) => {
        return (
          <Textarea
            {...rest}
            disabled={disabled}
            expandOnType
            maxHeight={160}
            maxLength={INVOICE_LINE_DESCRIPTION_CONTENT_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedTextareaChange(event.target.value)
            }}
            rows={1}
            placeholder={t('external_invoices.editor.form.field.line.field.description_content.placeholder')}
            resizable={false}
            value={value}
          />
        )
      }}
    />
  )
}
